import { render, staticRenderFns } from "./segunda-via.vue?vue&type=template&id=4312eb6c&"
import script from "./segunda-via.vue?vue&type=script&lang=js&"
export * from "./segunda-via.vue?vue&type=script&lang=js&"
import style0 from "./segunda-via.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports